import React from "react";
import { Link } from "react-router-dom";

export function CompetitionAuthGate({
  eyebrow = "Competition access",
  title = "Sign in to continue",
  children,
  signInPath = "/auth/sign-in",
  primaryLabel = "Sign In",
  links = [],
  className = "",
}) {
  return (
    <section className={`leaderboard-card app-gate-panel competition-route-panel ${className}`.trim()}>
      <div className="app-gate-eyebrow">{eyebrow}</div>
      <h2>{title}</h2>
      {children && <div className="app-gate-copy">{children}</div>}
      <div className="app-gate-actions">
        <Link to={signInPath} className="match-search-button leaderboard-inline-link">
          {primaryLabel}
        </Link>
        {links.map((link) => (
          <Link
            key={`${link.to}:${link.label}`}
            to={link.to}
            className="registration-auth-secondary leaderboard-inline-link"
          >
            {link.label}
          </Link>
        ))}
      </div>
    </section>
  );
}

export function CompetitionErrorState({
  eyebrow = "Competition",
  title = "This page could not load",
  message,
  onRetry,
  links = [],
  className = "",
}) {
  return (
    <section className={`leaderboard-card app-gate-panel competition-route-panel ${className}`.trim()}>
      <div className="app-gate-eyebrow">{eyebrow}</div>
      <h2>{title}</h2>
      {message && <p>{message}</p>}
      <div className="app-gate-actions">
        {onRetry && (
          <button type="button" className="match-search-button" onClick={onRetry}>
            Try Again
          </button>
        )}
        {links.map((link, index) => (
          <Link
            key={`${link.to}:${link.label}`}
            to={link.to}
            className={`${index === 0 && !onRetry ? "match-search-button" : "registration-auth-secondary"} leaderboard-inline-link`}
          >
            {link.label}
          </Link>
        ))}
      </div>
    </section>
  );
}

export function TechnicalIdDisclosure({ label = "Technical ID", value }) {
  const normalized = String(value || "").trim();
  if (!normalized) {
    return null;
  }

  return (
    <details className="technical-id-disclosure">
      <summary>{label}</summary>
      <code>{normalized}</code>
    </details>
  );
}
